import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ButtonComponent } from '@examdojo/core/button';
import { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { JsonEditorComponent } from '@examdojo/core/json-editor';
import { distinctUntilChanged, map, startWith } from 'rxjs';
import { connectState } from '@examdojo/angular/util';
import { QuestionItemsJsonEditorDirective } from './question-items-json-editor.directive';

@Component({
  selector: 'dojo-json-editor-dialog',
  template: `
    <ion-header [translucent]="true" class="shadow-none">
      <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
        <div slot="start" class="hidden md:flex">
          <dojo-icon-button (click)="closeDialog()" [icon]="'times'" />
        </div>
        <ion-title class="common-ion-title">Edit JSON</ion-title>
        <div slot="end" class="hidden md:flex md:w-8"></div>
      </ion-toolbar>
    </ion-header>
    <ion-content [scrollY]="false">
      <div class="flex h-full w-full">
        <dojo-json-editor dojoQuestionItemsJsonEditor [formCtrl]="control" />
      </div>
    </ion-content>
    <ion-footer class="border-t border-neutral-200 shadow-none">
      <div class="flex w-full items-center justify-between gap-2 px-2 py-4 md:px-4">
        <dojo-button [customColor]="'primary'" [fill]="'outline'" (click)="closeDialog()">
          Discard changes
        </dojo-button>
        <dojo-button [customColor]="'primary'" [disabled]="!state.enableSave" (click)="save()"> Save </dojo-button>
      </div>
    </ion-footer>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonHeader,
    IonContent,
    IonFooter,
    JsonEditorComponent,
    QuestionItemsJsonEditorDirective,
    ButtonComponent,
    IonToolbar,
    IconButtonComponent,
    IonTitle,
  ],
})
export class JsonEditorDialogComponent implements OnInit {
  constructor(private readonly modalCtrl: ModalController) {}

  @Input() data!: string;

  readonly control = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required],
  });

  private readonly isControlValid$ = this.control.statusChanges.pipe(
    startWith(this.control.status),
    map((status) => status === 'VALID'),
    distinctUntilChanged(),
  );

  readonly state = connectState({
    enableSave: this.isControlValid$,
  });

  closeDialog() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.control.setValue(this.data, { emitEvent: false });
  }

  async save() {
    if (this.control.invalid) {
      return;
    }
    this.modalCtrl.dismiss(this.control.value ?? '[]');
  }
}
